import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import {
  StandardTextFieldProps,
  TextField as MuiTextField,
  SxProps,
  Theme
} from '@mui/material';
import Button from '../../../Button';

interface NumberInputProps extends StandardTextFieldProps {
  name?: string;
  label?: string;
  defaultValue?: number;
  sx?: SxProps<Theme>
}

const NumberInput: FC<NumberInputProps> = ({ name, label, defaultValue, sx = [], ...props }) => {
  const { control, setValue, getValues } = useFormContext();

  const increment = () => {
    let currentValue: number = Number(getValues(`${name}`));
    setValue(`${name}`, currentValue + 1);
  }

  const decrement = () => {
    let currentValue = Number(getValues(`${name}`));
    setValue(`${name}`,
      currentValue !== 0
        ? currentValue - 1
        : 0);
  }

  return (
    <Controller
      name={name ? name : ''}
      defaultValue={defaultValue}
      control={control}
      render={({
        field,
        field: { onChange, value },
        fieldState
      }) => (
        <Stack
          direction="column"
          spacing={1}>
          {label &&
            <Typography>{label}</Typography>
          }
          <Stack
            direction="row"
            spacing={2}>
            <Button
              disabled={props?.disabled}
              onClick={decrement}
              sx={{ width: '45px' }}>
              <Typography>-</Typography>
            </Button>
            <MuiTextField
              {...field}
              sx={[
                {
                  maxWidth: '65px',
                  backgroundColor: 'white',
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused fieldset": {
                      borderImage: 'linear-gradient(#c2171d, #ff9e2d) 30%',
                      borderWidth: '2px',
                    },
                    "& input": {
                      textAlign: 'center'
                    }
                  }
                },
                ...(Array.isArray(sx) ? sx : [sx])
              ]}
              fullWidth
              variant="outlined"
              value={value}
              {...props}
              onChange={(e) => setValue(`${name}`, e.target.value)}
            />
            <Button
              disabled={props?.disabled}
              onClick={increment}
              sx={{ width: '45px' }}>
              <Typography>+</Typography>
            </Button>
          </Stack>
          <Typography variant="errorFont">
            {fieldState.error?.message}
          </Typography>
        </Stack>
      )} />
  );
}

export default NumberInput;
